import {
  JOB_STATES,
  FINISHED_STATES,
  RUNNING_STATES,
} from "app/constants/JobStates";

export function isJobRunning(job: any) {
  return Object.prototype.hasOwnProperty.call(
    RUNNING_STATES,
    job.state.toUpperCase(),
  );
}

export function isJobFinished(job: any) {
  return Object.prototype.hasOwnProperty.call(
    FINISHED_STATES,
    job.state.toUpperCase(),
  );
}

export function hasJobFailed(job: any) {
  switch (job.type) {
    case "script":
    case "trigger":
      return !job.passed;
    case "manual":
    case "waiter":
      return false;
  }
}

export function hasJobPassed(job: any) {
  switch (job.type) {
    case "script":
    case "trigger":
      return job.passed;
    case "manual":
      return true;
    case "waiter":
      return job.state.toUpperCase() === JOB_STATES.FINISHED;
  }
}

export function jobTime(job: any) {
  const { state, startedAt, finishedAt, canceledAt, timedOutAt } = job;
  const time: Record<string, any> = {};

  // job never stared, so no duration to show
  if (!startedAt) {
    return time;
  }

  time.from = startedAt;

  switch (state.toUpperCase()) {
    case JOB_STATES.FINISHED:
      time.to = finishedAt;
      break;

    case JOB_STATES.CANCELED:
    case JOB_STATES.CANCELING:
      time.to = canceledAt;
      break;

    case JOB_STATES.TIMED_OUT:
    case JOB_STATES.TIMING_OUT:
      time.to = timedOutAt;
      break;
  }

  return time;
}
